import React, { useEffect, useState } from 'react'
import CustomLoader from '../../CustomComponents/loader/CustomLoader'
import EditDeleteIcon from '../../CustomComponents/EditDeleteIcon';
import HttpClient from '../../utils/HttpClient';
import DataTable from 'react-data-table-component';
import moment from 'moment';
import toast from 'react-hot-toast';
import { DeleteConfirmModal } from '../../CustomComponents/DeleteConfirmModal';
import { Link, useNavigate } from 'react-router-dom';
import DetailsModal from '../../Component/Modal/DetailsModal';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import checktick from "../../Images/check-mark.png"
import user from "../../Images/user.png"
import userhistory from "../../Images/bills.png"
import cards from "../../Images/hand-gesture.png"
import partner from "../../Images/partnership-icon-10404.jpg"
import crossIcon from "../../Images/remove-icon-png-7115.png"
import './ViewTable.css'
import BusinessLIstingModal from '../../Component/Modal/BusinessLIstingModal';



const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "11px",
    fontWeight: "bold"

}
const customStyles = {
    rows: {
        style: {
            minHeight: '48px', // override the row height
        },
    },
    headCells: {
        style: {
            paddingLeft: '8px', // override the cell padding for head cells
            paddingRight: '8px',
            backgroundColor: '#cee0eb', // set the background color for head cells
        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
        },
    },
};
const format1 = "DD-MM-YYYY, h:mm a"


const ViewTable = () => {
    const [AllData, setAllData] = useState([]);
    const [ExcelSheetData, setExcelSheetData] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isBusinessModalOpen, setIsBusinessModalOpen] = useState(false);
    const [selectedDetails, setSelectedDetails] = useState("");
    const [searchInput, setSearchInput] = useState('');
    const [filterCountryState, setfilterCountryState] = useState(false);
    const navigate = useNavigate()

    // console.log(AllData.map((item,i)=>item.id), "AllData")
    // column
    const columns = [
        {
            name: 'SL',
            selector: row => row.sl,
            width: "3.4rem",
            // wrap: true
        },
        {
            name: 'Customer#',
            selector: row => row.customerNo,
            // width: "3.4rem",
            // wrap: true
        },
        {
            name: 'View',

            cell: (row) => (
                <i className="fa-solid fa-eye " onClick={() => handleView(row.id)}
                    style={{ cursor: "pointer", color: 'darkBlue', fontSize: '12px' }}></i>
            ),
            width: "3.4rem"
        },

        {
            name: 'Business Listing',

            cell: (row) => (
                <>
                    {
                        row.businessStatus && (
                            <>
                                <i className="fa-solid fa-eye " onClick={() => handleBusinessView(row.id)}
                                    style={{ cursor: "pointer", color: 'darkBlue', fontSize: '12px' }}></i>
                            </>
                        )
                    }
                </>
            ),

            width: "3.4rem",
            wrap: true,
        },
        // {
        //     name: 'Company Type',
        //     selector: row => row.TypeOfCompany,
        //     width: "8.4rem"
        // },
        {
            name: 'Company Name',
            selector: row => row.companyName,
            width: "12.4rem",
            wrap: true
        },
        // {
        //     name: 'Service Type',
        //     selector: row => row.service,
        //     width: "6.4rem"
        // },
        {
            name: 'Person Name',
            selector: row => row.personName,
            width: "12rem",
            wrap: true
        },
        // {
        //     name: 'designation',
        //     selector: row => row.designation,
        //     width: "5.6rem"
        // },
        {
            name: 'Email',
            selector: row => row.emailId,
            width: "13.4rem"
        },
        {
            name: 'Designation',
            selector: row => row.designation,
            width: "13.4rem"
        },
        // {
        //     name: 'telephoneNo',
        //     selector: row => row.telephoneNo,
        //     width: "6.2rem"
        // },
        {
            name: 'Mobile No',
            selector: row => row.mobileNo,
            width: "10.7rem"

        },
        {
            name: 'Directory',
            selector: row => row.directoryCount,
            width: "5.7rem"

        },
        {
            name: 'Reward Point',
            selector: row => row.rewardPoints,
            width: "8.7rem",
            wrap: true


        },


        // {
        //     name: 'whatsappNo',
        //     selector: row => row.whatsappNo,
        //     width: "6.5rem"
        // },

        // {
        //     name: 'websiteLink',
        //     selector: row => row.websiteLink,
        //     width: "10rem"
        // },
        // {
        //     name: 'address',
        //     selector: row => row.address,
        // },
        // {
        //     name: 'location',
        //     selector: row => row.location,
        //     width: "6.5rem"
        // },
        // {
        //     name: 'userName',
        //     selector: row => row.userName,
        // },

        // {
        //     name: 'dribbbleLink',
        //     selector: row => row.dribbbleLink,
        //     width: "8.5rem"
        // },
        // {
        //     name: 'facebookLink',
        //     selector: row => row.facebookLink,
        //     width: "8.5rem"
        // },
        // {
        //     name: 'instaLink',
        //     selector: row => row.instaLink,
        //     width: "8.5rem"
        // },
        // {
        //     name: 'linkedInLink',
        //     selector: row => row.linkedInLink,
        //     width: "8.5rem"
        // },
        // {
        //     name: 'youtubeLink',
        //     selector: row => row.youtubeLink,
        //     width: "8.5rem"
        // },
        {
            name: 'Activation Code',
            selector: row => row.activationCode,
            width: "10.7rem"

        },
        {
            name: 'Date & Time Created',
            selector: row => row.createdOn,
            width: "10.7rem"

        },
        {
            name: 'Upgraded Status',
            selector: row => row.upgradeStatus && row.upgradeStatus,
            width: "10.7rem"

        },
        {
            name: 'Partner Status',
            selector: row => row.partnerStatus,
            width: "10.7rem"

        },
        {
            name: 'Upgraded Date',
            selector: row => row.upgradeDate,
            width: "10.7rem"

        },
        {
            name: 'Activation Status',
            selector: row => row.loginStatus,
            width: "10.7rem"

        },
        {
            name: 'Status',
            selector: row => row.status,
            width: "10.7rem"

        },

        {
            name: 'Action',
            selector: row => row.action,
        },
        {
            name: 'History Details',
            selector: row => row.History,
            width: "8.7rem",


        },
        {
            name: 'Country',
            selector: row => row.country,
            width: "13.7rem",

        },
        {
            name: 'Emirate',
            selector: row => row.emirate,
            width: "13.7rem",

        }
    ];

    const getCategoryWiseData = async () => {
        setIsLoading(true);
        const res = await HttpClient.requestData("user", "GET", {});
        let apiData = []
        if (res && res?.status) {
            setIsLoading(false);
            apiData = res?.data?.map((item, i) => ({
                id: item?._id,
                sl: i + 1,
                TypeOfCompany: item?.TypeOfCompany,
                companyName: item?.companyName,
                service: item?.service,
                personName: item?.gender + ". " + item?.personName,
                designation: item?.designation,
                emailId: item?.emailId,
                telephoneNo: item?.telephoneNo,
                mobileNo: item?.mobileNo,
                whatsappNo: item?.whatsappNo,
                rewardPoints: item?.rewardPoints,
                directoryCount: item?.directoryCount,
                upgradeStatus: item?.upgradeStatus ?
                    <img src={checktick} className='w-25 mx-4' /> :
                    <img src={user} className='w-25 mx-4' />,
                partnerStatus: !item?.partnerStatus ?
                    <img src={crossIcon} className='w-25 mx-4' /> :
                    <img src={partner} className='mx-3' style={{ width: "50px" }} />,
                upgradeDate: item?.upgradeDate ? moment(item?.upgradeDate).format(format1) : "N/A",
                websiteLink: item?.websiteLink,
                address: item?.address,
                location: item?.location,
                userName: item?.userName,
                phone_code: item?.phone_code,
                whats_code: item?.whats_code,
                activationCode: item?.activationCode,
                createdOn: moment(item?.createdOn).format(format1),
                loginStatus: item?.loginStatus ? <button

                    type="button" className="btn btn-success floating-message px-3"
                    data-toggle="tooltip" data-placement="top" title="Click to Deactivate"
                    style={{ fontSize: "16px" }}>Active</button> : <button

                        type="button" className="btn btn-danger floating-message px-3"
                        data-toggle="tooltip" data-placement="top" title="Click to Activate">
                    Inactive
                </button>,
                dribbbleLink: item?.dribbbleLink,
                facebookLink: item?.facebookLink,
                instaLink: item?.instaLink,
                linkedInLink: item?.linkedInLink,
                youtubeLink: item?.youtubeLink,
                country: item?.country,
                emirate: item?.emirate,
                designation: item?.designation,
                businessStatus: item?.businessStatus,
                customerNo: item?.SLNo || "",
                ////
                telephoneNo: item?.telephoneNo,
                businessWebsiteLink: item?.businessWebsiteLink,
                webAddress: item?.webAddress,
                emirate: item?.emirate,
                countryName: item?.countryName,



                status: <div>
                    {
                        item?.status === "Pending" ? <button
                            onClick={() => handleActive(item?._id)}
                            type="button" className="btn btn-danger floating-message px-3"
                            data-toggle="tooltip" data-placement="top" title="Click to Activate">
                            Pending
                        </button> : <button
                            onClick={() => handlePending(item?._id)}
                            type="button" className="btn btn-success floating-message px-3"
                            data-toggle="tooltip" data-placement="top" title="Click to Deactivate"
                            style={{ fontSize: "16px" }}>{item?.status}</button>
                    }
                </div>,

                action: <EditDeleteIcon

                    onClickEdit={(e) => handleEdit(item)}
                    onClickDelete={(e) => handleDelete(item?._id)}
                />,
                History: <div><Link to={`/purchase-history/${item?._id}`}><img src={userhistory} style={{ width: "35px", height: "35px", cursor: "pointer" }} title="Purchase History" /></Link>
                    <Link to={`/reward-history/${item?._id}`}><img src={cards} style={{ width: "35px", height: "35px", cursor: "pointer", marginLeft: "10px" }} title='Reward History' /></Link></div>,


            }));
            // setExcelSheetData(res?.data?.map((item, i) =>
            // ({
            //     TypeOfCompany: item?.TypeOfCompany,
            //     companyName: item?.companyName,
            //     service: item?.service,
            //     personName: item?.gender + ". " + item?.personName,
            //     designation: item?.designation,
            //     emailId: item?.emailId,
            //     telephoneNo: item?.telephoneNo,
            //     mobileNo: item?.mobileNo,
            //     activationCode: item?.activationCode,
            //     whatsappNo: item?.whatsappNo,
            //     websiteLink: item?.websiteLink,
            //     address: item?.address,
            //     location: item?.location,
            //     userName: item?.userName,
            //     dribbbleLink: item?.dribbbleLink,
            //     facebookLink: item?.facebookLink,
            //     instaLink: item?.instaLink,
            //     linkedInLink: item?.linkedInLink,
            //     youtubeLink: item?.youtubeLink,
            //     PeopleType: item?.userType ? item?.userType : "Not Mentioned",

            // })
            // ))
        } else {
            setIsLoading(false);
        }

        // Filter data based on search input
        const filteredData = apiData?.filter(item =>
            item?.personName?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.companyName?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.country?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.emirate?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.designation?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.emailId?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.mobileNo?.toString()?.includes(searchInput) ||
            item?.customerNo?.toString()?.toLowerCase()?.includes(searchInput?.toLowerCase())

        );

        setAllData(filteredData);
        setExcelSheetData(filteredData)
    }

    //MODAL VIEW
    const handleView = async (id) => {

        setSelectedDetails(id);
        setIsModalOpen(true);
    }
    //BUSINESSMODAL VIEW
    const handleBusinessView = async (id) => {

        setSelectedDetails(id);
        setIsBusinessModalOpen(true);
    }
    //Activate
    const handlePending = async (id) => {
        setIsLoading(true);
        const data = {
            "status": "Pending"
        }

        const res = await HttpClient.requestData(`activateUser/${id}`, "PUT", data);
        if (res && res?.status) {
            setIsLoading(false);
            toast.success("Status Deactivated Successfully");
            getCategoryWiseData();
        } else {
            setIsLoading(false);
        }
    }
    //Pending
    const handleActive = async (id) => {
        setIsLoading(true);
        const data = {
            "status": "Active"
        }

        const res = await HttpClient.requestData(`activateUser/${id}`, "PUT", data);
        if (res && res?.status) {
            setIsLoading(false);
            toast.success("Status Activated Successfully");
            getCategoryWiseData();
        }
    }
    //Delete
    const handleDelete = (id) => {
        const del = async () => {
            setIsLoading(true);
            const res = await HttpClient.requestData("user/" + id, "DELETE")
            if (res && res?.status) {
                setIsLoading(false);
                getCategoryWiseData();

                toast.success("id Deleted Successfully");
            } else {
                setIsLoading(false);
                toast.error(res?.message || "Something Wrong");
            }
        }

        DeleteConfirmModal(del);
    }

    //edit
    const handleEdit = (item) => {
        navigate("/add-user-form", { state: item })
    }

    //Downloload EXCEL DATA
    // Function to export data to Excel
    // const exportToExcel = () => {
    //     const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    //     const fileExtension = '.xlsx';
    //     const fileName = 'users_data';

    //     const ws = XLSX.utils.json_to_sheet(ExcelSheetData);
    //     const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    //     const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    //     const data = new Blob([excelBuffer], { type: fileType });
    //     saveAs(data, fileName + fileExtension);
    // };
    const exportToExcel = () => {
        const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";
        const fileName = "members_data";

        const exportMembers = ExcelSheetData.map((item, idx) => ({
            customerNo: item.customerNo || "",
            companyName: item.companyName || "",
            typeOfBusiness: item.TypeOfCompany || "",
            personName: item.personName || "",
            designation: item.designation || "",
            emailId: item.emailId || "",
            contactNumber: item.phone_code ? `${item.phone_code}${item.telephoneNo}` : item.telephoneNo,
            contactNumber2: item.phone_code ? `${item.phone_code}${item.mobileNo}` : item.mobileNo,
            website: item.businessWebsiteLink || item.webAddress,
            state: item.emirate,
            country: item.countryName

            // directoryCount: Number(item.directoryCount) || 0,
            // businessStatus: Boolean(item.businessStatus),
            // fullMobile: item.phone_code ? `${item.phone_code}${item.mobileNo}` : item.mobileNo,
        }));

        const headerMap = {
            customerNo: "Customer ID",
            companyName: "Company Name",
            typeOfBusiness: "Type Of Business",
            personName: "Person Name",
            designation: "Designation",
            emailId: "Email Id",
            contactNumber: "Contact Number",
            contactNumber2: "Contact Number 2",
            website: "Website",
            state: "State",
            country: "Country"
        };

        const fields = Object.keys(headerMap);
        const dataWithHeaders = exportMembers.map((row) =>
            fields.map((field) => row[field])
        );

        dataWithHeaders.unshift(Object.values(headerMap));

        const ws = XLSX.utils.aoa_to_sheet(dataWithHeaders);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

        const data = new Blob([excelBuffer], { type: fileType });
        saveAs(data, fileName + fileExtension);
    };

    useEffect(() => {
        getCategoryWiseData();
    }, [searchInput])
    return (
        <div className="d-flex justify-content-end">
            <div className="form-header">

                <CustomLoader loading={isLoading} />
                <section className="piechartsBox_area">
                    <div
                        style={headLineStyle}
                        className="page-headline"
                    >
                        ALL USERS
                    </div>
                    <div className=" d-flex justify-content-between  mb-2" >
                        {/* filter by country and state */}
                        {!filterCountryState &&
                            <div className="d-flex flex-column  justify-content-between  mt-3" >
                                {/* <div className='mb-2'>
                                    <label htmlFor="formGroupExampleInput">Country<span className="text-danger">&nbsp;</span></label>
                                    <select class="hello">
                                        <option selected value="0">Pure CSS Select</option>
                                        <option value="1">No Wrapper</option>
                                        <option value="2">No JS</option>
                                        <option value="3">Nice!</option>
                                    </select>
                                </div>
                                <div>
                                    <label htmlFor="formGroupExampleInput">Emirate <span className="text-danger">&nbsp;</span></label>
                                    <select class="hello">
                                        <option selected value="0">Pure CSS Select</option>
                                        <option value="1">No Wrapper</option>
                                        <option value="2">No JS</option>
                                        <option value="3">Nice!</option>
                                    </select>
                                </div> */}
                            </div>}
                        <div className="Search_box">
                            <form className="form-inline">
                                <input
                                    className="form-control h-75"
                                    type="search"
                                    placeholder="Search"
                                    aria-label="Search"
                                    value={searchInput}
                                    onChange={(e) => setSearchInput(e.target.value)}
                                />
                                <div className="Search_icon">
                                    <i className="fa-solid fa-magnifying-glass"></i>
                                </div>
                            </form>
                            <div className="d-flex justify-content-end">
                                {/* Your existing JSX code */}
                                <button className="btn btn-primary" onClick={exportToExcel}>Export to Excel</button>
                                {/* Your existing JSX code */}
                            </div>
                        </div>
                    </div>


                    <form>

                        <div>

                            <DataTable
                                columns={columns}
                                data={AllData}
                                pagination
                                striped
                                className=" rounded "
                                customStyles={customStyles}
                            />
                        </div>
                    </form>
                </section>
            </div>
            <DetailsModal
                isOpen={isModalOpen}
                closeModal={() => setIsModalOpen(false)}
                details={selectedDetails}
            />
            <BusinessLIstingModal
                isOpen={isBusinessModalOpen}
                closeModal={() => setIsBusinessModalOpen(false)}
                details={selectedDetails}
            />
        </div>
    )
}

export default ViewTable; 